import { TeethTrackingStatuses } from 'components/Patients/TreatmentTracker/txTrackerConsts'
import { useMemo } from 'react'
import useTxTrackerAnalysis from './useTxTrackerAnalysis'
import { AnalysisThemes, AnalysisTypes } from './aiScanAnalysisConsts'
import useOralHygieneAnalysis from './useOralHygieneAnalysis'
import { OralScores } from 'consts/oralScoreConsts'
import useAlignersAnalysis from './useAlignersAnalysis'
import { useFetchGrinScanForScanTaggingQuery } from 'store/modules/ScanTagging'

export default ({ scanId }) => {
  const { data: grinScan, isLoading } = useFetchGrinScanForScanTaggingQuery({ grinScanId: scanId }, { skip: !scanId })

  const { scanOverallTrackingStatus, txTrackerAnalysisMessage } = useTxTrackerAnalysis({
    treatmentTrackerData: grinScan?.treatmentTrackerData
  })
  const { oralHygieneAnalysis, oralHygieneAnalysisMessage } = useOralHygieneAnalysis({
    scanSummaryData: grinScan?.scanSummaryData
  })
  const { IPRAlignerReached, lastAlignerReached } = useAlignersAnalysis({
    applianceIndex: grinScan?.applianceIndex,
    scanPairId: grinScan?.scanPairId
  })

  const analysisThemes = useMemo(
    () => ({
      [AnalysisThemes.Optimal]: {
        dotColor: '#26C36F',
        backgroundColor: '#E9F9F1'
      },
      [AnalysisThemes.Good]: {
        dotColor: '#A0CB7F',
        backgroundColor: '#EBFAE0'
      },
      [AnalysisThemes.Fair]: {
        dotColor: '#FFBD39',
        backgroundColor: '#FFF5E1'
      },
      [AnalysisThemes.PayAttention]: {
        dotColor: '#EB5757',
        backgroundColor: '#FDEEEE'
      },
      [AnalysisThemes.Aligners]: {
        backgroundColor: '#F2F3F5'
      },
      [AnalysisThemes.Neutral]: {
        dotColor: '#829DE3',
        backgroundColor: '#CAD9FF'
      }
    }),
    []
  )

  const analysisThemeByType = useMemo(
    () => ({
      [AnalysisTypes.TxTracker]: {
        [TeethTrackingStatuses.Tracking]: AnalysisThemes.Optimal,
        [TeethTrackingStatuses.PartiallyTracking]: AnalysisThemes.Fair,
        [TeethTrackingStatuses.NotTracking]: AnalysisThemes.PayAttention,
        [TeethTrackingStatuses.Fast]: AnalysisThemes.Neutral,
        [TeethTrackingStatuses.Moderate]: AnalysisThemes.Neutral,
        [TeethTrackingStatuses.Slow]: AnalysisThemes.Neutral,
        [TeethTrackingStatuses.NoSignificantMovement]: AnalysisThemes.Neutral
      },
      [AnalysisTypes.OralHygiene]: {
        [OralScores.Excellent]: AnalysisThemes.Optimal,
        [OralScores.Good]: AnalysisThemes.Good,
        [OralScores.Fair]: AnalysisThemes.Fair,
        [OralScores.Bad]: AnalysisThemes.PayAttention
      }
    }),
    []
  )

  return {
    isLoading,
    scanOverallTrackingStatus,
    txTrackerAnalysisMessage,
    oralHygieneAnalysis,
    oralHygieneAnalysisMessage,
    IPRAlignerReached,
    lastAlignerReached,
    analysisThemeByType,
    analysisThemes,
    AnalysisTypes
  }
}
